import script from "./Course.vue?vue&type=script&lang=ts&name=Course&setup=true"
export * from "./Course.vue?vue&type=script&lang=ts&name=Course&setup=true"

import "./Course.vue?vue&type=style&index=0&id=6aa3d4c2&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa3d4c2"]])

export default __exports__